import { Announcement } from "@/interfaces/announcement";

function formatDate(timestamp: string) {
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export default function Announcements({
  announcements,
}: {
  announcements: Announcement[];
}) {
  if (announcements.length === 0) return null;

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h2 className="font-display text-title text-ink font-bold">
          Announcements
        </h2>
        <p className="text-body text-ink-muted">
          Click on any of them to read the full thing!
        </p>
      </div>

      <div className="flex flex-col gap-5">
        {announcements.map((announcement, index) => (
          <a
            key={index}
            href={announcement.permalink}
            target="_blank"
            rel="noopener noreferrer"
            className="border-line bg-surface shadow-card duration-fast ease-standard flex w-full flex-col border-2 transition-transform hover:-translate-y-0.5"
          >
            <div className="border-line bg-titlebar-alt h-6 border-b-2" />
            <div className="flex w-full flex-1 flex-col gap-4 overflow-clip px-5 py-4">
              <div className="flex items-center gap-2">
                <img
                  src={announcement.author_avatar_url}
                  className="h-8 w-8 rounded-full object-cover"
                  alt={announcement.author_name}
                />

                <span className="font-display text-subheading text-ink font-bold">
                  @{announcement.author_name}
                </span>

                {formatDate(announcement.timestamp) && (
                  <span className="text-caption text-ink-soft ml-auto font-medium">
                    {formatDate(announcement.timestamp)}
                  </span>
                )}
              </div>

              {announcement.content && (
                <div
                  className="text-body text-ink-muted [&_code]:bg-ink/5 leading-snug [&_a]:underline [&_code]:rounded [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-base [&_p]:mt-3.5 [&_p:first-child]:mt-0"
                  dangerouslySetInnerHTML={{ __html: announcement.content }}
                />
              )}

              {announcement.images && announcement.images.length > 0 && (
                <div className="flex flex-wrap gap-3">
                  {announcement.images.map((image, imageIndex) => (
                    <img
                      key={imageIndex}
                      src={image.url}
                      width={image.width ?? undefined}
                      height={image.height ?? undefined}
                      alt=""
                      loading="lazy"
                      style={{
                        aspectRatio:
                          image.width && image.height
                            ? `${image.width} / ${image.height}`
                            : undefined,
                        maxWidth: image.width
                          ? `min(${image.width}px, 28rem)`
                          : "28rem",
                      }}
                      className="border-line max-h-[28rem] w-full border-2 object-contain"
                    />
                  ))}
                </div>
              )}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
